import { useEffect, useRef, useState } from "react";
import ContentBody from "./ContentBody";

export default function Home({ selectedAthlete, showEvent, showTraining }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const scope = params.get("scope");

    if (code) {
      const expectedState = sessionStorage.getItem("oauthState");
      sessionStorage.removeItem("oauthState");
      if (!expectedState || state !== expectedState) {
        console.error("OAuth state mismatch — possible CSRF attack, aborting.");
        window.history.replaceState({}, "", "/");
        return;
      }
      fetch(`${process.env.REACT_APP_BACKEND_URL}/strava/callback`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code, scope })
      })
        .then(r => r.json())
        .then(() => { window.location.href = "/onboarding"; });
    }

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content/home`)
      .then(res => res.json())
      .then(setContent)
      .catch(err => console.error(`Error loading ${pageKey} content`, err));
  }, []);

  if (!content) return null;

  return (
    <div className="pane">
      <h1>{content.title}</h1>
      <ContentBody data={content} />
    </div>
  );
}
